export default {
  id: 184,
  title: 'Target #184 - India',
  url: 'https://cssbattle.dev/play/184',
  colors: ['#00007B', '#3F8627', '#F19E4B', '#FFFFFF'],
  solution:
    '<style>body{background:linear-gradient(#f19e4b 100px,transparent 100px 200px,#3f8627 200px),radial-gradient(circle,#00007b 10px,transparent 10px 30px,#00007b 30px 40px,#fff 40px),linear-gradient(90deg,transparent 198px,#00007b 198px 202px,transparent 202px),linear-gradient(30deg,transparent 228px,#00007b 228px 232px,transparent 232px),linear-gradient(-30deg,transparent 228px,#00007b 228px 232px,transparent 232px)}</style>',
}
